jQuery(document).ready(function () {
    jQuery(function () {
        var dateFormat = "dd. M y",
        from = jQuery("#from")
            .datepicker({
                numberOfMonths: 1,
                dateFormat: dateFormat,
                minDate: 0,
                showWeek: true,
                firstDay: 1
            })
            .on("change", function () {
                to.datepicker("option", "minDate", getDate(this));
            }),

        to = jQuery("#to")
        .datepicker({
            numberOfMonths: 1,
            dateFormat: dateFormat,
            minDate: 0,
            showWeek: true,
            firstDay: 1
        })
        .on("change", function () {
            from.datepicker("option", "maxDate", getDate(this));
        });

        function getDate(element) {
            var date;
            try {
                date = jQuery.datepicker.parseDate(dateFormat, element.value);
            } catch (error) {
                date = null;
            }

            return date;
        }
    });
});